export default __webpack_public_path__ + "static/media/mission-to-zero.d6bdad51.webp";